<div class="whitelevel-loader" role="status" aria-label="Loading">
    <div class="whitelevel-loader__spinner"></div>
    <div class="whitelevel-loader__label">Loading</div>
</div>
